import { isNativeAppRuntime } from '@/config/runtime'

const DEFAULT_ANDROID_NAV = 48
const DEFAULT_IOS_HOME = 34

/** Estima insets do sistema (barra de navegação Android / home iOS) na WebView. */
export function applyNativeSafeAreaInsets(): () => void {
  if (typeof window === 'undefined' || !isNativeAppRuntime()) {
    return () => {}
  }

  const root = document.documentElement
  const isAndroid = /Android/i.test(navigator.userAgent || '')

  const update = () => {
    let bottom = isAndroid ? DEFAULT_ANDROID_NAV : DEFAULT_IOS_HOME

    const vv = window.visualViewport
    if (vv) {
      const gap = Math.max(0, window.innerHeight - vv.height - vv.offsetTop)
      if (gap >= 20) bottom = Math.max(bottom, Math.ceil(gap))
    }

    root.style.setProperty('--native-nav-bottom', `${bottom}px`)
  }

  update()
  window.visualViewport?.addEventListener('resize', update)
  window.visualViewport?.addEventListener('scroll', update)
  window.addEventListener('resize', update)

  return () => {
    window.visualViewport?.removeEventListener('resize', update)
    window.visualViewport?.removeEventListener('scroll', update)
    window.removeEventListener('resize', update)
    root.style.removeProperty('--native-nav-bottom')
  }
}
